import { apiGet } from './apiClient';

export interface ProjectFile {
  id: string;
  file_name: string;
  file_path: string;
  file_type: string;
  project_id: string;
  uploaded_at: string;
}

export const getProjectFiles = async (projectId: string): Promise<ProjectFile[]> => {
  try {
    const payload = await apiGet<{ data: ProjectFile[] }>(`/projects/${encodeURIComponent(projectId)}/files`);
    return payload?.data || [];
  } catch (error) {
    console.error('Ошибка в getProjectFiles:', error);
    throw error;
  }
};

export const downloadFile = async (file: ProjectFile): Promise<void> => {
  try {
    console.log('Скачивание файла:', file);
    
    // Проверяем, является ли file_path URL или путем в Storage
    if (file.file_path.startsWith('http://') || file.file_path.startsWith('https://')) {
      console.log('Используем прямую ссылку:', file.file_path);
      // Прямая ссылка - создаем временную ссылку для скачивания
      const link = document.createElement('a');
      link.href = file.file_path;
      link.download = file.file_name;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      throw new Error('Файл не содержит прямой URL. Требуется миграция file_path на https-ссылки.');
    }
  } catch (error) {
    console.error('Ошибка скачивания файла:', error);
    throw error;
  }
};
